export default {
  avatar: {
    title: "Ubah avatar",
  },
  bindRole: {
    allServers: "Semua Server",
    bindFailed: "Bind karakter gagal",
    bindSuccess: "Bind karakter berhasil",
    getRoleListFailed: "Gagal mendapatkan daftar karakter",
    getServerListFailed: "Gagal mendapatkan daftar server",
    modifyTitle: "Ubah bind karakter",
    noRole: "Belum ada karakter",
    recentServers: "Server Anda",
    role: "Nama Karakter:",
    rolePlaceholder: "Pilih karakter",
    server: "Server:",
    serverPlaceholder: "Silakan pilih server",
    title: "Bind Karakter",
  },
  commentModal: {
    placeholder: "Tulis komentar...",
    replyTo: "Balas {username}",
    title: "Komentar",
  },
  common: {
    cancel: "Batal",
    confirm: "Konfirmasi",
    landscapeTip:
      "Silakan putar ponsel Anda ke mode potret untuk pengalaman yang lebih baik",
    loadMore: "Tarik ke atas untuk memuat lebih banyak",
    loading: "Memuat...",
    loadingMore: "Memuat lainnya...",
    noMore: "Tidak ada data lagi",
    refreshFailed: "Gagal memperbarui",
    refreshSuccess: "Berhasil diperbarui",
    submit: "Kirim",
    all: "Semua",
    language: "Bahasa",
  },
  error: {
    50002: "Token tidak valid atau kedaluwarsa",
    50006: "Nama panggilan ini sudah dipakai",
    50007:
      "Anda hanya dapat mengubah nama panggilan sekali per bulan, Anda sudah mengubahnya bulan ini",
    50008: "Poin Kurang",
    50301: "Anda tidak punya izin memposting",
    50302: "Sudah mencapai batas maksimum posting",
    50303: "Panjang konten tidak memenuhi persyaratan",
    50304: "Konten mengandung kata sensitif, harap ubah dan coba lagi",
    50308: "Anda tidak memiliki izin untuk melihat postingan ini",
    50309: "Postingan telah dihapus atau dipindahkan",
    50351: "Topik telah ditutup, tidak bisa dibalas",
    50353: "Anda tidak punya izin membalas",
    50354: "Balasan dilarang di forum ini",
    50355: "Terlalu sering posting, coba lagi nanti",
    50356: "Jumlah postingan per jam sudah mencapai batas",
    50361: "Komentar tidak ditemukan",
    50500: "Anda tidak memiliki izin untuk mencari",
    50501: "Fitur pencarian telah dinonaktifkan",
    50502: "Konten mengandung kata sensitif, harap ubah dan coba lagi",
    50505: "Pencarian terlalu sering, silakan coba lagi nanti",
    50703: "Review gambar tidak lolos",
    50704: "Konten gambar tidak sesuai aturan",
    50214: "Berbagi gagal: Anda belum bergabung dengan @:shareModal.alliance.",
    common: "Gagal. Coba lagi nanti",
  },
  home: {
    gameName: "Puzzles & Survival",
    hasSigned: "Sudah absen",
    loginInSuccess: "Login berhasil",
    pleaseLogin: "Silakan login",
    loginNow: "Masuk",
    pullToRefresh: "Tarik ke bawah untuk refresh",
    releaseToRefresh: "Lepaskan untuk refresh",
    signFailed: "Gagal absen",
    signIn: "Absen",
    signInFailedTip: "Gagal absen, coba lagi nanti",
    signSuccess: "Berhasil absen",
    goToShop: "Ke Pusat Poin",
    sortByLastPost: "Komentar terbaru",
    sortByTime: "Terbaru",
    tags: {
      activity: "Event",
      chats: "Obrolan",
      guide: "Panduan",
      recommend: "Rekomendasi",
      news: "Berita",
    },
    unboundRole: "Belum bind karakter",
  },
  linkModal: {
    close: "Close",
    textLabel: "Link Text",
    textPlaceholder: "Please enter link text",
    title: "Insert Link",
    urlLabel: "Link URL",
    urlPlaceholder: "Please enter link URL",
    viewTitle: "View Link",
  },
  maintenance: {
    title: "Halaman Sedang Dirawat",
    message:
      "Maaf, forum game sedang dalam perawatan. Silakan coba lagi nanti.",
  },
  mentionModal: {
    searchPlaceholder: "Cari pengguna",
    title: "Pilih pengguna",
  },
  nicknameModify: {
    alreadyRenamed:
      "Nick hanya bisa diubah sekali sebulan, Anda sudah mengubahnya bulan ini",
    changedNickname: "Ubah Nick",
    cost: "Konsumsi",
    date: "Tanggal",
    getMore: "Dapatkan",
    nicknameTooShort: "Nick minimal 3 karakter",
    coinNotEnough: "Poin Kurang",
    placeholder: "Masukkan nick",
    recordTitle: "Riwayat perubahan",
    sameNickname: "Nick baru tidak boleh sama dengan yang sekarang",
    success: "Edit Disimpan",
    viewRecord: "Lihat riwayat perubahan",
  },
  notice: {
    empty: "Tidak ada pesan",
    likeComment: "{username} menyukai komentarmu",
    likePost: "{username} menyukai postinganmu",
    mentionComment: "{username} menyebutmu di komentar",
    mentionPost: "{username} menyebutmu di postingan",
    replyComment: "{username} membalas komentarmu",
    replyPost: "{username} membalas postinganmu",
    system: "Notifikasi sistem",
    tabs: {
      like: "Suka",
      mention: "Mention",
      notification: "Pemberitahuan",
      reply: "Balasan untukku",
    },
    title: "Notifikasi",
  },
  operateModal: {
    confirmDelete: "Yakin ingin menghapus postingan ini?",
    copyFailed: "Gagal menyalin",
    copyLink: "Salin tautan",
    copySuccess: "Berhasil disalin",
    delete: "Hapus",
    shareToGame: "Bagikan ke dalam game",
    deleteFailed: "Gagal menghapus",
    deleteSuccess: "Berhasil dihapus",
    title: "Aksi",
  },
  shareModal: {
    selectChannelTitle: "Silakan pilih saluran untuk dibagikan",
    channelLabel: "Saluran",
    channelPlaceholder: "Pilih saluran",
    alliance: "Aliansi",
    shareSuccess: "Berhasil dibagikan",
    continueBrowse: "Lanjutkan menjelajah",
    goToGame: "Lihat di game",
    noThreadTip: "Buka postingan terlebih dahulu",
  },
  post: {
    create: {
      contentEmpty: "Konten tidak boleh kosong",
      contentPlaceholder: "Apa yang ingin kamu katakan saat ini...",
      failed: "Gagal diposting",
      fileTooLarge: "Ukuran file melebihi batas (maks. {maxSize})",
      image: "Gambar",
      imageSizeLimit: "Ukuran gambar tidak boleh melebihi 5MB",
      imageUploadFailed: "Gagal unggah gambar",
      imageUploadSuccess: "Berhasil unggah gambar",
      imageUploading: "Mengunggah gambar, harap tunggu...",
      invalidFileType: "Jenis file tidak didukung",
      maxCharsReached: "Batas maksimum karakter tercapai ({max} karakter)",
      mention: "{'@'}",
      selectBoard: "Pilih kategori",
      topicLabel: "Topik",
      submit: "Unggah",
      submitting: "Memposting...",
      success: "Berhasil diposting",
      title: "Posting",
      titleEmpty: "Tema tidak boleh kosong",
      titlePlaceholder: "Masukkan tema",
      video: "Video",
      videoSizeLimit: "Ukuran video tidak boleh melebihi 50MB",
      videoUploadFailed: "Gagal unggah video",
      videoUploadSuccess: "Berhasil unggah video",
      videoUploading: "Mengunggah video, harap tunggu...",
    },
    title: "Postingan",
  },
  postDetail: {
    allComments: "Semua {num} balasan",
    allReplies: "Balas Semua",
    author: "Kreator",
    cancelFavorite: "Telah dihapus dari favorit",
    commentTooShort: "Komentar minimal 5 karakter",
    translate: "Terjemahkan",
    translating: "Menerjemahkan...",
    translateSuccess: "Terjemahan berhasil",
    translateFailed: "Terjemahan gagal",
    translatedTo: "Diterjemahkan ke",
    earliest: "Balasan terlama",
    favoriteSuccess: "Berhasil simpan favorit",
    floor: "di komentar",
    latest: "Balasan terbaru",
    loadFailed: "Gagal memuat",
    noContent: "Belum ada konten",
    onlyAuthor: "Hanya kreator",
    reply: "Balas",
    replyTo: "Balas",
    sendFailed: "Gagal mengirim",
    sendSuccess: "Berhasil terkirim",
    sending: "Mengirim...",
    viewOriginalPost: "Lihat postingan asli",
    writeSomething: "Tulis sesuatu...",
  },
  profile: {
    addLikeSuccess: "Berhasil suka",
    cancelLikeSuccess: "Berhasil batal suka",
    communityId: "ID Komunitas",
    editNickname: "Ubah Nick",
    followSuccess: "Berhasil Mengikuti",
    followed: "Sudah mengikuti",
    followers: "Pengikut",
    follow: "Mengikuti",
    likes: "Mendapat suka",
    noFavorites: "Belum ada favorit",
    noPosts: "Belum ada aktivitas",
    shopLabel: "Toko Poin",
    tabs: {
      favorites: "Favoritku",
      posts: "Aktivitasku",
    },
    title: "Profilku",
    unfollowSuccess: "Berhasil Batal Mengikuti",
  },
  search: {
    btn: "Cari",
    empty: "Tidak ada hasil pencarian",
    filter: {
      dateline: "Terbaru",
      title: "Urutkan",
      views: "Populer",
    },
    historyTitle: "Riwayat pencarian",
    hotTitle: "Trending",
    relatedPosts: "Postingan Terkait",
    tabs: {
      post: "Postingan",
      user: "Pengguna",
    },
  },
  setting: {
    about: "Tentang Kami",
    logout: "Logout",
    logoutSuccess: "Berhasil logout",
    privacy: "Kebijakan Privasi",
    service: "Ketentuan Layanan",
    title: "Pengaturan",
  },
  shop: {
    emptyTip: "Toko sedang dibangun, harap tunggu~",
    record: "Riwayat Penukaran",
    title: "Pusat Penukaran",
    bindRole: "Bind Karakter",
    switchRole: "Switch Character",
    tabs: {
      tasks: "Tugas poin",
      rewards: "Tukar hadiah",
    },
    taskInProgress: "Sedang berlangsung",
    taskCompleted: "Selesai",
    goToComplete: "Selesaikan",
    exchange: "Tukar",
    exchanged: "Ditukar",
    exchangeConfirmTitle: "Konfirmasi penukaran?",
    currentCoins: "Poin saat ini",
    costCoins: "Poin yang dikonsumsi",
    receiveRole: "Karakter penerima",
    exchangeSuccess: "Penukaran berhasil",
    exchangeFailed: "Penukaran gagal",
  },
  exchangeRecord: {
    time: "Waktu",
    content: "Konten",
    points: "Poin",
    empty: "Tidak ada riwayat penukaran",
  },
  tabBar: {
    home: "Beranda",
    notice: "Pesan",
    profile: "Milikku",
  },
  time: {
    hoursAgo: "{hours} jam lalu",
    minutesAgo: "{minutes} menit lalu",
  },
};
